export default __webpack_public_path__ + "static/media/Automotive Application.53db85f4.jpg";